<script>
  import { isProxy, toRaw } from 'vue';
  export default {
    name: 'ProductListBottomPillBadge',
    props: {
      tags: Array,
      collectionId: String,
      badgeHideConfig: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        alt: '',
        badgeDetails: window.productBadges?.pillbadges,
        badgeTag: '',
        img: '',
        isProcessing: false,
        plpHide: window.productBadges?.plp_pill_hide,
        rank: 15,
        showBadge: false,
        showOverrideBadge: false
      };
    },
    computed: {
      badgeAltText() {
        const shopName = window.Shopify.cdnHost.replace('/cdn', '');
        return this.alt || shopName + ' ' + 'badge image';
      }
    },
    mounted() {
      const overrideEventName = window.productBadges?.overrideEventName;
      if (overrideEventName) {
        window.addEventListener(overrideEventName, event => {
          this.showOverrideBadge = event.detail === true;
          this.setTag();
        });
        if (window.productBadges?.[overrideEventName] === true) {
          this.showOverrideBadge = true;
        }
      }
      this.setTag();
    },
    watch: {
      tags: function () {
        this.setTag();
      }
    },
    methods: {
      reset() {
        this.rank = 15;
        this.showBadge = false;
        this.img = '';
        this.alt = '';
        this.badgeTag = '';
      },
      /**
       * Check if a badge should be hidden for the current collection
       * @param {string} badgeKey - Specific badge identifier
       * @returns {boolean} True if badge should be hidden
       */
      isHidden(badgeKey) {
        if (!this.badgeHideConfig?.pill || !this.collectionId) return false;
        const badgeSet = this.badgeHideConfig.pill[badgeKey];
        if (!badgeSet) return false;
        const normalizedCollectionId = this.collectionId.replace(/[\s_-]/g, '');
        return badgeSet.has(normalizedCollectionId);
      },
      setTag() {
        this.reset();
        if (this.isProcessing) {
          return;
        }
        this.isProcessing = true;
        requestAnimationFrame(() => {
          this.performTagUpdate();
          this.isProcessing = false;
        });
      },
      shouldShowOverrideImage(badgeData) {
        if (this.showOverrideBadge === true && badgeData.img_override) {
          return badgeData.img_override;
        }
        return badgeData.img;
      },
      performTagUpdate() {
        let badges = this.badgeDetails;
        if (isProxy(badges)) {
          badges = toRaw(badges);
        }
        let tags = this.tags;
        if (isProxy(tags)) {
          tags = toRaw(tags);
        }
        const matchingBadges = [];
        for (const key in badges) {
          const badgeTag = badges[key]['tag'];
          const found = tags.find(element => element === badgeTag);
          if (found) {
            matchingBadges.push({
              tag: badgeTag,
              rank: badges[key]['rank'],
              img: this.shouldShowOverrideImage(badges[key]),
              alt: badges[key]['alt'] || ''
            });
          }
        }
        if (matchingBadges.length === 0) {
          this.reset();
          return;
        }
        matchingBadges.sort((a, b) => a.rank - b.rank);
        for (const badge of matchingBadges) {
          const badgeKey = `pill_badge_image_tag_${badge.rank}`;
          const shouldHideThisBadge = this.isHidden(badgeKey);
          if (shouldHideThisBadge) {
            this.reset();
            return;
          }
          this.showBadge = !this.plpHide;
          this.rank = badge.rank;
          this.img = badge.img;
          this.alt = badge.alt;
          this.badgeTag = badge.tag;
          return;
        }
        this.reset();
      }
    }
  };
</script>

<template>
  <div v-if="showBadge && img" class="pillbadges" :data-badge-tag="badgeTag">
    <img :src="img" class="badge-image" :alt="badgeAltText" />
  </div>
</template>

<style lang="scss">
  .pillbadges {
    position: absolute;
    display: flex;
    justify-content: center;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, calc(50% + var(--pill-badge-y-offset, 0px)));
    z-index: var(--z-card-overlay);
    width: 100%;
    text-align: center;
    pointer-events: none;

    img {
      max-width: 120px;
      &.hide {
        display: none;
      }
    }
  }

  .collection-product-slider .pillbadges {
    transform: translate(-50%, calc(30% + var(--pill-badge-y-offset, 0px)));

    .is-mobile & {
      transform: translate(-50%, calc(0% + var(--pill-badge-y-offset, 0px)));
    }
  }

  #pdp-recommendations .pillbadges,
  [data-recently-viewed-products] .pillbadges {
    transform: translate(-50%, calc(-50% + var(--pill-badge-y-offset, 0px)));
    justify-content: center;
    bottom: inherit;
  }

  .product-single .pillbadges {
    transform: translateY(-80%);
    justify-content: flex-start;
  }

  .pdp-badge-router {
    .pillbadges {
      position: relative;
      bottom: auto;
      left: auto;
      right: auto;
      text-align: left;
    }
  }
</style>
